import { render } from "./BaseGridTable.vue?vue&type=template&id=6fb66238&scoped=true"
import script from "./BaseGridTable.vue?vue&type=script&lang=js"
export * from "./BaseGridTable.vue?vue&type=script&lang=js"

import "./BaseGridTable.vue?vue&type=style&index=0&id=6fb66238&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb66238"]])

export default __exports__